import { applyEmailSignatureToBody, validatePlaceholders } from './emailSignatureFunctions';

const normalizeCrmEmailModel = ({ crmEmailModel, getInitialSenderEmailAddress, emailAddresses }) => {
  if (!crmEmailModel) return crmEmailModel;

  const model = { ...crmEmailModel };
  const senderEmailItem = getInitialSenderEmailAddress(model.senderEmailAddressId, emailAddresses);

  if (senderEmailItem) {
    model.body = applyEmailSignatureToBody({
      emailAddressItem: senderEmailItem,
      emailBody: model.body,
      disableChange: true,
    });
  }

  if (model.body && model.mailMergeFields) {
    model.body = validatePlaceholders({
      emailBody: model.body,
      mailMergeFields: model.mailMergeFields,
    });
  }

  return model;
};

export default normalizeCrmEmailModel;

